import React, { useState } from 'react';
import UploadAssetModal from '../my-stuff/upload-asset/UploadAssetModal';
import { Input, Button } from 'antd';
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons';
import styles from './quest-settings.module.css';

export const CollectableInput = ({
  identifier,
  deleteItem,
  type,
  userEmail,
  enableSave,
  defaultValue = null,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [value, setValue] = useState(defaultValue ?? '');
  const [disabled, setIsDisabled] = useState(false);

  function loadAsset({ url }) {
    setValue(() => url);
    setIsDisabled(true);
  }

  return (
    <div className={styles.collectableInput}>
      <Input
        placeholder='URL'
        onChange={(e) => {
          setValue(e.target.value);
          enableSave();
        }}
        id={`${identifier}`}
        value={value}
        disabled={disabled}
      />
      <div className={styles.buttons}>
        <Button onClick={() => setIsVisible(true)} type='dashed'>
          <UploadOutlined />
        </Button>
        <Button onClick={() => deleteItem(identifier, type)} type='dashed'>
          <DeleteOutlined style={{ color: 'red' }} />
        </Button>
      </div>
      <UploadAssetModal
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        callback={loadAsset}
        userEmail={userEmail}
      />
    </div>
  );
};
